import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { AvatarModule } from '@libs/src/avatar/avatar.module';
import { ChipModule } from '@libs/src/chip/chip.module';
import { GroupOfferingsPickerModule } from '@libs/src/group-offerings-picker/group-offerings-picker.module';
import { GroupTopicsPickerModule } from '@libs/src/group-topics-picker/group-topics-picker.module';
import { ProgressStepsModule } from '@libs/src/progress-steps/progress-steps.module';
import { ToastModule } from '@libs/src/toast/toast.module';
import { TtcButtonSharedModule } from '@libs/src/ttc-button-shared/ttc-button-shared.module';
import { GroupCustomSegmentSelectorModule } from '@main-client/src/app/group-segment-selector/group-custom-segment-selector.module';
import { FindPipeModule } from '@main-client/src/app/pipes/find-pipe/find-pipe.module';
import { GroupMembershipPipeModule } from '@main-client/src/app/pipes/group-membership-pipe/group-membership-pipe.module';
import { TranslationLookupListModule } from '@main-client/src/app/pipes/translation-lookup-list/translation-lookup-list.module';
import { TranslationLookupModule } from '@main-client/src/app/pipes/translation-lookup/translation-lookup.module';
import { UserOnboardingErrorDialogModule } from '@main-client/src/app/user-onboarding/user-onboard-error-dialog/user-onboarding-error-dialog.module';
import { UserOnboardingProgramFormModule } from '@main-client/src/app/user-onboarding/user-onboarding-program-form/user-onboarding-program-form.module';

import { UserOnboardingHubPreferencesViewComponent } from './user-onboarding-hub-preferences-view.component';

@NgModule({
  declarations: [UserOnboardingHubPreferencesViewComponent],
  exports: [UserOnboardingHubPreferencesViewComponent],
  imports: [
    AvatarModule,
    ChipModule,
    CommonModule,
    FindPipeModule,
    FlexLayoutModule,
    GroupCustomSegmentSelectorModule,
    GroupMembershipPipeModule,
    GroupOfferingsPickerModule,
    GroupTopicsPickerModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatProgressBarModule,
    MatSelectModule,
    NzSelectModule,
    NzToolTipModule,
    ProgressStepsModule,
    ReactiveFormsModule,
    ToastModule,
    TranslationLookupListModule,
    TranslationLookupModule,
    TtcButtonSharedModule,
    UserOnboardingErrorDialogModule,
    UserOnboardingProgramFormModule,
  ],
})
export class UserOnboardingHubPreferencesViewModule {}
